import { Component } from '@theme/component';

/**
 * Butonul „înapoi sus”: apare după ce ai derulat cel puțin un ecran și te duce lin sus
 * (instant la `prefers-reduced-motion`). De la 990px în sus derulează `.page-wrapper`, nu fereastra
 * (vezi `assets/base.css`), așa că ascultăm ambele.
 *
 * @extends {Component}
 */
class PerdeleSus extends Component {
  /** @type {AbortController | undefined} */
  #abort;

  #frame = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    const update = () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#sync());
    };
    window.addEventListener('scroll', update, { passive: true, signal });
    window.addEventListener('resize', update, { passive: true, signal });
    document.querySelector('.page-wrapper')?.addEventListener('scroll', update, { passive: true, signal });
    this.#sync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abort?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #sync() {
    const wrapper = document.querySelector('.page-wrapper');
    const top = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
    this.toggleAttribute('data-visible', top > window.innerHeight);
  }

  /** Derulează la început și mută focusul pe primul link din header, ca tastatura să nu rămână în gol. */
  scrollToTop() {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, behavior });
    document.querySelector('.page-wrapper')?.scrollTo({ top: 0, behavior });
    const links = document.querySelectorAll('#header-component a[href]');
    const first = Array.from(links).find((link) => link instanceof HTMLElement && link.offsetParent !== null);
    if (first instanceof HTMLElement) first.focus({ preventScroll: true });
  }
}

if (!customElements.get('perdele-sus')) customElements.define('perdele-sus', PerdeleSus);
